(async () => {
    const { Core } = await importModule('Core');

    customElements.define('collection-filter', class extends Core {
        render() {
            this.addEventListener('change', this._changeHandler.bind(this));

            if(this.querySelector(".show_more_options")){
              var show_more_option = this.querySelector(".show_more_options");
              
               var filter = this.querySelector("ul");
                var heigth_limit = 0;
                for(var i=0; i < filter.querySelectorAll('li').length; i++) {
                  var item = filter.querySelectorAll('li')[i];

                  heigth_limit = heigth_limit + (item.getBoundingClientRect().height + ((0.8) * parseFloat(getComputedStyle(document.documentElement).fontSize)));
                  if(i == 5) {
                    break;
                  }
                }
                
                if(show_more_option) {
                  filter.setAttribute('data-heigth_limit', heigth_limit);
                  filter.style.maxHeight = heigth_limit+'px';
                  show_more_option.style.display = 'inline-block';
                }
      

          show_more_option.addEventListener('click', function(e) {
          e.preventDefault();
          
          var filters_list = this.previousElementSibling;
          var heigth_limit = filters_list.getAttribute('data-heigth_limit');
          var default_text = this.getAttribute('data-default-text');
          
          if(this.classList.contains("openedFilter")) {    
          	filters_list.style.maxHeight  = heigth_limit+'px';
            this.classList.remove('openedFilter');
            this.innerHTML = default_text;
          } else {

            var filterBlockLength = 0;
            for(var i=0; i < filters_list.querySelectorAll('li').length; i++) {
              var item = filters_list.querySelectorAll('li')[i];
              filterBlockLength = filterBlockLength + (item.getBoundingClientRect().height + ((0.8) * parseFloat(getComputedStyle(document.documentElement).fontSize)));
            }
            filters_list.style.maxHeight = filterBlockLength+'px';
            this.classList.add('openedFilter');
            this.innerHTML = this.getAttribute("data-show-less");

          }
        });
          
        }
           
        }
        _changeHandler(e) {
            this.publish('filter:change');
        }        
    })
})();